import { HStack, VStack } from "@gluestack-ui/themed";
import { Button } from "@repo/core/components/core/Button";
import { Icon } from "@repo/core/components/core/Icon";
import { IconNames } from "@repo/core/components/core/Icon/types";
import { Text } from "@repo/core/components/core/Text";

import { DocumentsViewProps, ProposalDocument } from "./types";

export const DocumentsView = ({
  documents,
  onViewDocument
}: DocumentsViewProps) => {
  if (!documents || documents.length === 0) {
    return (
      <VStack alignItems="center" justifyContent="center" py="$8">
        <Text fontSize="$sm" color="$textLight600" textAlign="center">
          Nenhum documento encontrado
        </Text>
      </VStack>
    );
  }

  const handleViewDocument = (document: ProposalDocument) => {
    if (onViewDocument) {
      onViewDocument(document);
    }
  };

  return (
    <VStack gap="$10">
      {documents.map((item, index) => (
        <VStack key={index}>
          <HStack mb="$2" alignItems="center">
            <VStack width="$5">
              <Icon name="paperclip-vertical" size={14} />
            </VStack>
            <Text fontSize="$xs" fontWeight={500} color="$textLight800">
              {item.type}
            </Text>
          </HStack>
          <HStack mb="$4" gap="$2" alignItems="center">
            <VStack>
              <Icon name={item.icon as IconNames} size={32} />
            </VStack>
            <VStack gap="$1" flex={1}>
              <Text fontSize="$md" fontWeight={600} color="$textLight900">
                {item.title}
              </Text>
              <Text fontSize="$xs" fontWeight={400} color="$textLight800">
                Adicionado em {item.date}
              </Text>
            </VStack>
          </HStack>
          <HStack gap="$4">
            {/* <Button
              text="Substituir"
              variant="outline"
              size="sm"
              action="darker-secondary"
              leftIcon={{
                name: "pen-square",
                size: 16
              }}
            /> */}
            <Button
              text={item.buttonLabel}
              size="sm"
              variant="solid"
              action="secondary"
              flex={2}
              textStyle={{ color: "$primary700" }}
              leftIcon={{
                name: "eye",
                color: "$textLight0",
                hoverColor: "$textLight0",
                size: 16
              }}
              onPress={() => handleViewDocument(item)}
            />
          </HStack>
        </VStack>
      ))}
    </VStack>
  );
};
